import axios from 'axios';
import storeMain from '@/store';
// import router from '@/router';

export const moduleCampaigns = {
  state: {
    freerounds: [],
    optin: [],
    referafriend: [],
  },
  mutations: {
    setStatusCodeFantasy(state, payload){
      storeMain.commit('setStatusCode', payload);
    },
    setNotificationFantasy(state, message){
      storeMain.commit('setNotification', message);
    },
    getFreerounds(state, list){
      state.freerounds = list;
    },
    getOptin(state, list){
      state.optin = list;
    },
    getReferAFriend(state, list){
      state.referafriend = list;
    },
  },
  actions: {

    async getFreerounds({ commit, rootState }){
      const config = {
        headers: {Authorization: `bearer ${rootState.login.token}`},
      };
      console.log('llamando a get freerounds')
      axios
          .get(`${process.env.VUE_APP_SERVER}/backoffice/casino/freerounds/list`, config)
          .then((res) => {
            commit('getFreerounds', res.data);
          })
          .catch((error) => {
            console.log(error);
          });
    },

    async createFreerounds({ commit, rootState }, freeroundsData) {
      const config = {
        headers: {Authorization: `bearer ${rootState.login.token}`},
      };
      commit('setStatusCodeFantasy',  {key: 'createFreerounds', state:'', msg:'', loading: true});
      console.log(freeroundsData.data)
      axios
          .post(`${process.env.VUE_APP_SERVER}/backoffice/casino/freerounds/create`,freeroundsData.data, config)
          .then((res) => {
            commit('setStatusCodeFantasy', {key: 'createFreerounds', state: res.status, msg:res.statusText, loading: false});
            commit('setNotificationFantasy', 'Succesfully created freerounds');
          })
          .catch((error) => {
            commit('setStatusCodeFantasy', {key: 'createFreerounds', state: error.response.status, msg: error.response.statusText, loading: false});
            console.log(error);
          });
    },

    async toggleFreerounds({commit, rootState}, freeroundsData) {
      const config = {
        headers: {Authorization: `bearer ${rootState.login.token}`},
      };
      console.log('actualizando el estado de freerounds')
      commit('setStatusCodeFantasy',  {key: 'toggleFreerounds', state:'', msg:'', loading: true});
      axios
          .post(`${process.env.VUE_APP_SERVER}/backoffice/casino/freerounds/${freeroundsData}/toggle`, {}, config)
          .then((res) => {
            commit('setStatusCodeFantasy',  {key: 'toggleFreerounds', state: res.status, msg:res.statusText, loading: false});
          })
          .catch((error) => {
            commit('setStatusCodeFantasy',  {key: 'toggleFreerounds', state: error.response.status, msg: error.response.statusText, loading: false});
          });
    },

    // async editFreerounds({commit,rootState}, freeroundsData) {
    //   const config = {
    //       headers: {Authorization: `bearer ${rootState.login.token}`},
    //   };
    //   console.log('editando freerounds')
    //   commit('setStatusCodeFantasy',  {key: 'editFreerounds', state:'', msg:'', loading: true});
    //   axios
    //       .post(`${process.env.VUE_APP_SERVER}/backoffice/casino/freerounds/${freeroundsData._id}/edit`,freeroundsData.data, config)
    //       .then((res) => {
    //         commit('setStatusCodeFantasy',  {key: 'editFreerounds', state: res.status, msg:res.statusText, loading: false});
    //         commit('setNotificationFantasy', 'Succesfully edited Freerounds');
    //       })
    //       .catch((error) => {
    //         commit('setStatusCodeFantasy',  {key: 'editFreerounds', state: error.response.status, msg: error.response.statusText, loading: false});
    //         commit('setNotificationFantasy', `Freerounds can't be edited by ${error.response.statusText}`);
    //         console.log(error);
    //       });
    // },

    async getOptin({ commit, rootState }){
      const config = {
        headers: {Authorization: `bearer ${rootState.login.token}`},
      };
      console.log('llamando a get Opt-In')
      axios
          .get(`${process.env.VUE_APP_SERVER}/backoffice/casino/optin/list`, config)
          .then((res) => {
            commit('getOptin', res.data);
          })
          .catch((error) => {
            console.log(error);
          });
    },

    async createOptin({ commit, rootState }, optinData) {
      const config = {
        headers: {Authorization: `bearer ${rootState.login.token}`},
      };
      commit('setStatusCodeFantasy',  {key: 'createOptin', state:'', msg:'', loading: true});
      console.log(optinData.data)
      axios
          .post(`${process.env.VUE_APP_SERVER}/backoffice/casino/optin/create`,optinData.data, config)
          .then((res) => {
            commit('setStatusCodeFantasy', {key: 'createOptin', state: res.status, msg:res.statusText, loading: false});
            commit('setNotificationFantasy', 'Succesfully created Optin');
          })
          .catch((error) => {
            commit('setStatusCodeFantasy', {key: 'createOptin', state: error.response.status, msg: error.response.statusText, loading: false});
            console.log(error);
          });
    },

    async toggleOptin({commit, rootState}, optinData) {
      const config = {
        headers: {Authorization: `bearer ${rootState.login.token}`},
      };
      console.log('actualizando el estado de Opt-In')
      commit('setStatusCodeFantasy',  {key: 'toggleOptin', state:'', msg:'', loading: true});
      axios
          .post(`${process.env.VUE_APP_SERVER}/backoffice/casino/optin/${optinData}/toggle`, {}, config)
          .then((res) => {
            commit('setStatusCodeFantasy',  {key: 'toggleOptin', state: res.status, msg:res.statusText, loading: false});
          })
          .catch((error) => {
            commit('setStatusCodeFantasy',  {key: 'toggleOptin', state: error.response.status, msg: error.response.statusText, loading: false});
          });
    },

    async getReferAFriend({ commit, rootState }){
      const config = {
        headers: {Authorization: `bearer ${rootState.login.token}`},
      };
      console.log('llamando a get ReferAFriend')
      axios
          .get(`${process.env.VUE_APP_SERVER}/backoffice/casino/referafriend/list`, config)
          .then((res) => {
            commit('getReferAFriendn', res.data);
          })
          .catch((error) => {
            console.log(error);
          });
    },
  }
};
